export const article = [
  {
    articleId: 12,
    url: "planes-y-precios",
    category: {
      slug: "comenzar",
      name: "Comenzar"
    },
    title: "Planes y precios",
    content:
      <>
        <div className="row">
          <p>En Mega GO puedes encontrar los siguientes planes para elegir:</p>
        </div>
        <table>
          <thead>
            <tr>
              <th>Atributos</th>
              <th>Básico</th>
              <th>Light mensual</th>
              <th>Sports mensual</th>
              <th>Sports anual</th>
              <th>Full mensual</th>
              <th>Full anual</th>
              <th>Full Sports</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Costo (pesos chilenos)</td>
              <td align="center">Sin costo</td>
              <td align="center">
                $3.490
                <p style={{ fontSize: 14 }}>al mes</p>
              </td>
              <td align="center">
                $4.490
                <p style={{ fontSize: 14 }}>al mes</p>
              </td>
              <td align="center">
                $35.880*
                <p style={{ fontSize: 14 }}>el año</p>
              </td>
              <td align="center">
                $4.490
                <p style={{ fontSize: 14 }}>al mes</p>
              </td>
              <td align="center">
                $44.900
                <p style={{ fontSize: 14 }}>al año</p>
              </td>
              <td align="center">
                $6.490
                <p style={{ fontSize: 14 }}>al mes</p>
              </td>
            </tr>
            <tr>
              <td>Dispositivos conectados simultáneamente</td>
              <td align="center">2</td>
              <td align="center">2</td>
              <td align="center">2</td>
              <td align="center">2</td>
              <td align="center">2</td>
              <td align="center">2</td>
              <td align="center">2</td>
            </tr>
            <tr>
              <td>Señales en vivo: Mega, Mega 2, Teletrak, Meganoticias y Megatiempo</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>Radios: Carolina TV, Infinita, Romántica y FM Tiempo</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>Cultura y Actualidad</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>Señales en vivo: Mega Ficción y Moonbug (Kids)</td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>Capítulos de teleseries nacionales, series y programas</td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>La Roja rumbo al mundial 2030, transmisiones alternativas y otros eventos de primer nivel</td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>Capítulos sin publicidad</td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
            <tr>
              <td>
                ¡Preestrenos 24 horas antes que la tv!
                <p style={{ fontSize: 14 }}>En producciones originales, excepto primer y último capítulo</p>
              </td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center"></td>
              <td align="center">✓</td>
              <td align="center">✓</td>
              <td align="center">✓</td>
            </tr>
          </tbody>
        </table>
        <p>Se te cobrará automáticamente una vez por mes o año, dependiendo del plan que elijas, en la fecha de suscripción. Tienes total libertad para cambiar de plan o cancelar el servicio online en cualquier momento.</p>
        <p>*Sports anual es un pago único de $35.880, facturado en hasta 12 cuotas mensuales de $2.990 sin interés, y no se renueva automáticamente al finalizar el período.</p>
      </>
  }
];